//#region src/magic_copy_permission.ts
var MagicCopyPermission = /* @__PURE__ */ function(MagicCopyPermission) {
	MagicCopyPermission["ConfigurationOnly"] = "configuration-only";
	MagicCopyPermission["ConfigurationAndMenu"] = "configuration-and-menu";
	return MagicCopyPermission;
}(MagicCopyPermission || {});
//#endregion
export { MagicCopyPermission };

//# sourceMappingURL=magic_copy_permission.js.map